// Components
import { ESuperUserAccountType, ESalesAccountType, Role, UserType } from './userEnums';

const DEV_APP_API_URL = process.env.REACT_APP_API_URL || 'https://dev.users.cowpuncher.lol';
const REACT_APP_DATA_API_URL = process.env.REACT_APP_DATA_API_URL || "http://54.157.64.38:8001";
//const REACT_APP_API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

const RouteMapping: { [key: string]: string } = {
  [`${null}-${UserType.PERSONAL}-${null}`]: '/vcat-user/dashboard',
  [`${Role.ADMIN}-${UserType.MANAGED}-${ESuperUserAccountType.CLIENT}`]: '/client-admin/usage',
  [`${Role.ADMIN}-${UserType.MANAGED}-${ESuperUserAccountType.EYEVIATION}`]: '/client-admin/usage',
  [`${Role.USER}-${UserType.MANAGED}-${ESuperUserAccountType.CLIENT}`]: '/client-user',
  [`${Role.SUPER_USER}-${UserType.MANAGED}-${ESuperUserAccountType.EYEVIATION}`]: '/eyeviation-super/accounts',
  [`${Role.SUPER_USER}-${UserType.MANAGED}-${ESuperUserAccountType.CLIENT}`]: '/eyeviation-super/accounts',
  [`${Role.MODERATOR}-${UserType.MANAGED}-${ESalesAccountType.CLIENT}`]: '/sales/accounts',
  [`${Role.MODERATOR}-${UserType.MANAGED}-${ESalesAccountType.EYEVIATION}`]: '/sales/accounts',
};

export { RouteMapping, REACT_APP_DATA_API_URL, DEV_APP_API_URL };